<template>
  <div style="position: relative">
    <div id="activeShow"></div>
    <div style="position: absolute; left: -10000px" class="show" id="allShow">
      <div v-for="(pageItem, index) in pdfPage" :key="index + 'pdfPageitem'">
        <!-- 公司主体信息 -->
        <div
          class="template_con"
          v-if="pageItem.type == 'mainInfo' && pageItem.typeIndex == 0"
        >
          <div class="main back_1">
            <img
              :src="
                $store.state.userInfo.loginUser.permission === 'USER'
                  ? ''
                  : $store.state.brandLogo.fileUrl
              "
              class="logo"
            />

            <div class="vision-con">
              <div
                v-for="(vision, i) in splitVision(pageItem.data?.vision)"
                :key="i"
              >
                {{ vision }}
              </div>
            </div>
            <div class="mission-con">
              {{ pageItem.data?.mission }}
            </div>
            <img
              src="@/assets/img/pdfTemplate/template_1/mainbg1.png"
              class="mainbg1"
            />
          </div>
        </div>
        <div
          class="template_con"
          v-if="pageItem.type == 'mainInfo' && pageItem.typeIndex == 1"
        >
          <div class="main back_2">
            <div class="title-con">
              <span class="first-two">关于</span>我们
              <div class="subtitle-con">ABOUT US</div>
            </div>

            <div class="main-itd">
              {{ pageItem.data?.companyContent }}
            </div>
            <div class="history-con">
              <div
                class="history-item"
                v-for="(item, num) in pageItem?.data?.history.slice(0, 4)"
                :key="num"
                :style="{
                  width: `${100 / pageItem?.data?.history.slice(0, 4).length}%`,
                }"
              >
                <div class="time">
                  {{ dayjs(item?.historyTime).format("YYYY") }}年： 
                </div>
                <div class="item-detail">
                  {{ item?.history }}
                </div>
              </div>
            </div>
            <img
              src="@/assets/img/pdfTemplate/template_1/mainbg2.png"
              class="mainbg2"
            />
          </div>
        </div>
        <div
          class="template_con"
          v-if="pageItem.type == 'mainInfo' && pageItem.typeIndex == 2"
        >
          <div class="main back_3">
            <div class="title-con">
              <span class="first-two">关于</span>我们
              <div class="subtitle-con">ABOUT US</div>
            </div>
            <div
              class="history-con"
              v-if="
                pageItem?.data?.history.slice(
                  (index - 2) * 8 + 4,
                  (index - 2) * 8 + 8
                ).length
              "
            >
              <div
                class="history-item"
                v-for="(item, num) in pageItem?.data?.history.slice(
                  (index - 2) * 8 + 4,
                  (index - 2) * 8 + 8
                )"
                :key="num"
                :style="{
                  width: `${
                    100 /
                    pageItem?.data?.history.slice(
                      (index - 2) * 8 + 4,
                      (index - 2) * 8 + 8
                    ).length
                  }%`,
                }"
              >
                <div class="time">
                  {{ dayjs(item?.historyTime).format("YYYY") }}年： 
                </div>
                <div class="item-detail">
                  {{ item?.history }}
                </div>
              </div>
            </div>
            <div
              class="history-con"
              v-if="
                pageItem?.data?.history.slice(
                  (index - 2) * 8 + 8,
                  (index - 2) * 8 + 12
                ).length
              "
            >
              <div
                class="history-item"
                v-for="(item, num) in pageItem?.data?.history.slice(
                  (index - 2) * 8 + 8,
                  (index - 2) * 8 + 12
                )"
                :key="num"
                :style="{
                  width: `${
                    100 /
                    pageItem?.data?.history.slice(
                      (index - 2) * 8 + 8,
                      (index - 2) * 8 + 12
                    ).length
                  }%`,
                }"
              >
                <div class="time">
                  {{ dayjs(item?.historyTime).format("YYYY") }}年： 
                </div>
                <div class="item-detail">
                  {{ item?.history }}
                </div>
              </div>
            </div>
            <img
              src="@/assets/img/pdfTemplate/template_1/mainbg2.png"
              class="mainbg2"
            />
          </div>
        </div>
        <!-- 产品与服务内容 -->
        <div class="template_con" v-if="pageItem.type == 'productList'">
          <div
            class="main back_4"
            :style="{
              backgroundImage: `url(${require(`@/assets/img/pdfTemplate/template_1/product${
                ((index -
                  pdfPage.indexOf(
                    pdfPage.find((item) => item.type === 'productList')
                  )) %
                  3) +
                1
              }.png`)})`,
            }"
          >
            <div class="title-con">
              <span class="first-two">服务</span>与产品
              <div class="subtitle-con">SERVICES AND PRODUCTS</div>
            </div>
            <div class="product-title">
              <div class="product-name">
                {{ pageItem.data?.projectName }}
              </div>
              <div class="product-index">
                {{
                  `0${
                    index -
                    pdfPage.indexOf(
                      pdfPage.find((item) => item.type === "productList")
                    ) +
                    1
                  }`
                }}
              </div>
            </div>
            <div class="product-desc">
              {{ pageItem.data?.projectIntro }}
            </div>
            <div class="project-feature">
              {{ pageItem.data?.projectFeature }}
            </div>
          </div>
        </div>

        <!-- 项目与案例 0 -->
        <div
          class="template_con"
          v-if="pageItem.type == 'projectList' && pageItem.typeIndex == 0"
        >
          <div class="main back_5">
            <div class="title-con">
              <span class="first-two">优秀</span>作品
              <div class="subtitle-con">WORKS OF EXCELLENCE</div>
            </div>
            <div class="qrcode-con">
              <img
                :src="pageItem.data?.xcxQrCode"
                v-if="pageItem.data?.xcxQrCode"
                class="qrcode"
              />
              <img
                src="@/assets/img/pdfTemplate/template_1/qrcode.png"
                class="qrcodebg"
              />
            </div>

            <div class="project-con">
              <div class="left">
                <div class="project-name">
                  {{ pageItem?.data?.projectName }}
                </div>
                <div class="project-desc">
                  {{ pageItem?.data?.projectIntro }}
                </div>
              </div>
              <div class="right">
                <img :src="pageItem?.data?.workUrl" class="work-cover" />
              </div>
            </div>
            <div class="review-con">
              <div class="review-title">客户反馈</div>
              <div class="review-desc">
                {{ pageItem?.data?.projectFeature }}
              </div>
            </div>
            <img
              src="@/assets/img/pdfTemplate/template_1/project1.png"
              class="project1"
            />
          </div>
        </div>
        <!-- 荣誉与认证 0 -->
        <div
          class="template_con"
          v-if="pageItem.type == 'honorList' && pageItem.typeIndex == 0"
        >
          <div class="main back_6">
            <div class="title-con">
              <span class="first-two">荣耀</span>与认证
              <div class="subtitle-con">GLORY AND RECOGNITION</div>
            </div>
            <div class="honor-con">
              <div
                class="honor-item"
                v-for="(item, num) in pageItem.multipleData"
                :key="num"
              >
                <img :src="item.fileList[0].fileUrl" />
                <div class="honor-name">{{ item.content }}</div>
                <div class="honor-time">
                  颁发日期：{{ dayjs(item.approveTime).format("YYYY年MM月") }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 团队成员  -->
        <div
          class="template_con"
          v-if="pageItem.type == 'memberList' && pageItem.typeIndex == 0"
        >
          <div class="main back_7">
            <div class="title-con">
              <span class="first-two">团队</span>介绍
              <div class="subtitle-con">TEAM INTRODUCTION</div>
            </div>
            <div class="member-con">
              <div
                v-for="(item, num) in pageItem.multipleData"
                :key="num"
                class="team-member-item"
              >
                <div
                  class="member-bg"
                  :style="{
                    backgroundImage: `url(${require(`@/assets/img/pdfTemplate/template_1/member${
                      (num % 4) + 1
                    }.png`)})`,
                  }"
                >
                  <img
                    :src="item.editAvatar || item.avatar"
                    class="member-avatar"
                  />
                </div>
                <div class="member-info">
                  <div class="member-detail">
                    <span class="member-name">{{ item.nickname }}</span>
                    <span class="member-job">{{ item.job }}</span>
                  </div>
                  <div class="member-exp">{{ item.experience }}</div>
                  <div class="member-project">
                    {{ `${item.projectIntro}（${item.duty}）` }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 合作伙伴 -->
        <div
          class="template_con"
          v-if="pageItem.type == 'partnerList' && pageItem.typeIndex == 0"
        >
          <div class="main back_8">
            <div class="title-con">
              <span class="first-two">合作</span>伙伴
              <div class="subtitle-con">COOPERATIVE PARTNER</div>
            </div>
            <div class="parter-con">
              <div
                v-for="(item, num) in pageItem.multipleData"
                :key="num"
                class="partnar-item"
              >
                <img
                  :src="item.fileList ? item.fileList[0].fileUrl : null"
                  class="partnar-img"
                  v-if="item.isShow"
                  :id="item.tempId"
                />
                <div class="partner-name">{{ item.name }}</div>
                <div class="partner-time">
                  合作时间：{{ dayjs(item.approveTime).format("YYYY年") }}
                </div>
                <div class="partner-info">{{ item.content }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- 联系方式 0 -->
        <div
          class="template_con"
          v-if="pageItem?.type == 'contact' && pageItem.typeIndex == 0"
        >
          <div class="main back_9">
            <div class="title-con">
              <span class="first-two">联系</span>我们
              <div class="subtitle-con">CONTACT US</div>
            </div>
            <div class="contact-con">
              <div
                class="contact-column left"
                v-if="pageItem?.multipleData?.slice(0, 3).length"
              >
                <div
                  class="contact-item"
                  v-for="(item, num) in pageItem.multipleData.slice(0, 3)"
                  :key="num"
                >
                  <div class="item-label">
                    {{ item.name }}
                  </div>
                  <div class="item-value">电话：{{ item.tel }}</div>
                  <div class="item-value">微信：{{ item.wx }}</div>
                </div>
              </div>
              <div class="contact-column mid">
                <div class="contact-item">
                  <div class="item-label">企业邮箱</div>
                  <div class="item-value">
                    {{ pageItem?.data?.email }}
                  </div>
                </div>

                <div class="contact-item">
                  <div class="item-label">公司地址</div>
                  <div class="item-value">
                    {{ pageItem?.data?.city }}
                  </div>
                </div>
              </div>
              <div class="contact-column right">
                <div class="contact-item">
                  <div class="item-label">企业官微</div>
                  <div class="item-value">
                    <img class="wxqrcode" :src="pageItem?.data?.wxUrl" alt="" />
                  </div>
                </div>
              </div>
            </div>
            <img
              src="@/assets/img/pdfTemplate/template_1/contact1.png"
              class="contact-bg1"
            />
          </div>
        </div>
        <!-- 联系方式 1 -->
        <div
          class="template_con"
          v-if="pageItem?.type == 'contact' && pageItem.typeIndex == 1"
        >
          <div class="main back_10">
            <div class="title-con">
              <span class="first-two">联系</span>我们
              <div class="subtitle-con">CONTACT US</div>
            </div>
            <div class="contact-con" v-if="pageItem?.multipleData?.length">
              <div
                class="contact-column left"
                v-if="pageItem?.multipleData?.slice(0, 3).length"
              >
                <div
                  class="contact-item"
                  v-for="(item, num) in pageItem.multipleData.slice(0, 3)"
                  :key="num"
                >
                  <div class="item-label">
                    {{ item.name }}
                  </div>
                  <div class="item-value">电话：{{ item.tel }}</div>
                  <div class="item-value">微信：{{ item.wx }}</div>
                </div>
              </div>
              <div
                class="contact-column left"
                v-if="pageItem?.multipleData?.slice(3, 6).length"
              >
                <div
                  class="contact-item"
                  v-for="(item, num) in pageItem.multipleData.slice(3, 6)"
                  :key="num"
                >
                  <div class="item-label">
                    {{ item.name }}
                  </div>
                  <div class="item-value">电话：{{ item.tel }}</div>
                  <div class="item-value">微信：{{ item.wx }}</div>
                </div>
              </div>
              <div
                class="contact-column left"
                v-if="pageItem?.multipleData?.slice(6, 9).length"
              >
                <div
                  class="contact-item"
                  v-for="(item, num) in pageItem.multipleData.slice(6, 9)"
                  :key="num"
                >
                  <div class="item-label">
                    {{ item.name }}
                  </div>
                  <div class="item-value">电话：{{ item.tel }}</div>
                  <div class="item-value">微信：{{ item.wx }}</div>
                </div>
              </div>
            </div>

            <img
              src="@/assets/img/pdfTemplate/template_1/contact1.png"
              class="contact-bg1"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import dayjs from "dayjs";
import { splitVision } from "@/assets/js/common";
export default {
  name: "Template_1",
  props: ["activeBoardIndex", "pdfPage", "activePDFPage"],
  components: {},
  computed: {
    ...mapState(["userInfo", "activeCompanyInfo"]),
  },
  data() {
    return {};
  },
  methods: {
    dayjs,
    splitVision,
    extractImgSrc(html = "") {
      // 正则表达式匹配img标签中的src属性
      // 考虑了src可能有引号或无引号的情况，以及各种引号类型
      const regex = /<img[^>]+src=["']?([^"'>]+)["']?/gi;
      const srcArray = [];
      let match;

      // 循环查找所有匹配项
      while ((match = regex.exec(html)) !== null) {
        // 提取并保存src值
        srcArray.push(match[1]);
      }

      return srcArray;
    },
    checkArr(arr) {
      let newArr = [];
      if (Array.isArray(arr)) {
        newArr = arr;
      } else {
        newArr = [];
      }
      console.log(newArr);
      return newArr;
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.show {
  position: absolute;
  left: 30px;
  top: 30px;
  width: 800px;
  height: 800px;
  overflow: auto;
}

.template_con,
.template_con2 {
  word-break: break-all;
  width: 800px;
  height: 450px;
  overflow: hidden; // 防止内容溢出影响高度计算
  .main {
    width: 100%;
    height: 100%;
    padding: 26px 33px;
    position: relative;
    font-family: OPPOSans, OPPOSans;
    box-sizing: border-box; // 避免padding导致实际高度超过容器
    background: #020202;
    .title-con {
      font-family: OPPOSans, OPPOSans;
      font-weight: bold;
      font-size: 25px;
      color: #ffffff;
      position: relative;
      margin-bottom: 25px;
      .first-two {
        color: #e83628;
      }
      &:before {
        content: "";
        width: 25px;
        height: 2px;
        background: #e83628;
        position: absolute;
        bottom: 21px;
        left: 0;
      }
      .subtitle-con {
        margin-top: 16px;
        font-family: OPPOSans, OPPOSans;
        font-weight: 500;
        font-size: 8px;
        color: #999999;
      }
    }
  }
  .title-en {
    font-family: Heiti SC, Heiti SC;
    font-weight: 400;
    font-size: 28px;
    color: #3e3e3e;
    line-height: 29px;
    display: flex;
    align-items: center;
    position: relative;
    .title-bg {
      width: 25px;
      margin-left: 8px;
    }
    .qrcode {
      position: absolute;
      top: -15px;
      right: 0;
      width: 80px;
      height: 80px;
    }
  }
  .title {
    font-family: Source Han Sans, Source Han Sans;
    font-weight: 700;
    font-size: 21px;
    color: #ffe71d;
    line-height: 30px;
    position: relative;
    top: -13px;
    margin-bottom: 19px;
    &:after {
      position: absolute;
      content: "";
      left: 0;
      bottom: -13px;
      height: 1px;
      width: 30px;
      background: #ffe71d;
    }
  }
  .back_1 {
    height: 100%;
    position: relative;
    .mainbg1 {
      position: absolute;
      right: 0;
      top: 0;
      width: 360px;
    }
    .logo {
      height: 18px;
    }
    .vision-con {
      font-family: OPPOSans, OPPOSans;
      font-weight: 800;
      font-size: 50px;
      color: #ffffff;
      margin: 89px 0 27px;
      position: relative;
      width: 438px;
      z-index: 2;
    }
    .mission-con {
      font-family: OPPOSans, OPPOSans;
      font-weight: 400;
      font-size: 17px;
      color: #ffffff;
      width: 438px;
      position: relative;
      z-index: 2;
    }
  }
  .back_2 {
    height: 100%;
    position: relative;
    .main-itd {
      width: 489px;
      font-size: 13px;
      color: #eeeeee;
    }
    .history-con {
      display: flex;
      width: 702px;
      position: absolute;
      bottom: 80px;
      left: 26px;
      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 2px;
        background: linear-gradient(to right, #434343 50%, #090909);
      }
      .history-item {
        padding: 21px 14px 0 3px;
        position: relative;
        &::before {
          content: "";
          position: absolute;
          top: -1px;
          left: 4px;
          width: 4px;
          height: 4px;
          border-radius: 50%;
          background: #f7750f;
        }
        .time {
          font-family: OPPOSans, OPPOSans;
          font-weight: 800;
          font-size: 17px;
          color: #ffffff;
        }
        .item-detail {
          margin-top: 5px;
          font-size: 13px;
          color: #aaaaaa;
        }
      }
    }
    .mainbg2 {
      width: 169px;
      position: absolute;
      right: 5px;
      top: 0;
    }
  }
  .back_3 {
    height: 100%;
    position: relative;
    .history-con {
      display: flex;
      width: 702px;
      margin-bottom: 25px;
      height: 150px;
      position: relative;
      &:last-child {
        margin: 0;
      }
      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 2px;
        background: linear-gradient(to right, #434343 50%, #090909);
      }
      .history-item {
        padding: 21px 14px 0 3px;
        position: relative;
        &::before {
          content: "";
          position: absolute;
          top: -1px;
          left: 4px;
          width: 4px;
          height: 4px;
          border-radius: 50%;
          background: #f7750f;
        }
        .time {
          font-family: OPPOSans, OPPOSans;
          font-weight: 800;
          font-size: 17px;
          color: #ffffff;
        }
        .item-detail {
          margin-top: 5px;
          font-size: 13px;
          color: #aaaaaa;
        }
      }
    }

    .mainbg2 {
      width: 169px;
      position: absolute;
      right: 5px;
      top: 0;
    }
  }
  .back_4 {
    height: 100%;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center; // 确保背景图居中显示
    position: relative;
    .product-title {
      margin-top: 124px;
      font-weight: bold;
      font-size: 17px;
      color: #eeeeee;
      position: relative;
      margin-bottom: 10px;
      z-index: 2;
      .product-index {
        position: absolute;
        bottom: 5px;
        left: 0;
        height: 61px;
        font-family: DIN-BlackItalic, DIN-BlackItalic;

        opacity: 0.5; /* 半透明，避免遮挡文字 */
        filter: blur(1px); /* 轻微模糊，增强层次感 */
        color: #fff; /* 与文字同色，保持风格统一 */
        font-size: 50px;
        z-index: -1;
      }
    }
    .product-desc {
      font-size: 13px;
      color: #eeeeee;
      width: 360px;
    }
    .project-feature {
      position: absolute;
      width: 360px;
      bottom: 20px;
      left: 26px;
      font-size: 13px;
      color: #a0a0a0;
    }
  }
  .back_5 {
    height: 100%;
    // 或使用100% 100% + 调整定位
    position: relative;
    background-color: #161514;
    .project1 {
      position: absolute;
      top: 0;
      right: 0;
      width: 423px;
    }
    .qrcode-con {
      position: absolute;
      top: 25px;
      right: 33px;
      width: 83px;
      height: 83px;
      border-radius: 4px;
      z-index: 2;
      overflow: hidden;
      .qrcode {
        width: 100%;
        height: 100%;
      }
      .qrcodebg {
        width: 38px;
        height: 38px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
    .project-con {
      display: flex;
      padding-top: 44px;
      position: relative;
      z-index: 3;
      .left {
        width: 360px;
        margin-right: 75px;
        padding-top: 12px;
        .project-name {
          font-weight: bold;
          font-size: 17px;
          color: #eeeeee;
          margin-bottom: 10px;
        }
        .project-desc {
          font-size: 13px;
          color: #eeeeee;
        }
      }
      .right {
        flex: 1;
        min-width: 0;
        width: 179px;
        height: 175px;
        background-image: url("@/assets/img/pdfTemplate/template_1/project2.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center; // 确保背景图居中显示
        position: relative;
        z-index: 2;
        display: flex;
        align-items: center;
        justify-content: center;
        .work-cover {
          width: 275px;
          height: 117px;
        }
      }
    }
    .review-con {
      position: absolute;
      bottom: 25px;
      left: 33px;
      width: 360px;
      z-index: 2;
      .review-title {
        font-weight: bold;
        font-size: 13px;
        color: #d6d6d6;
      }
      .review-desc {
        font-size: 13px;
        color: #b6b6b6;
      }
    }
  }
  .back_6 {
    height: 100%;
    .honor-con {
      display: flex;
      .honor-item {
        padding: 24px 10px;
        margin-right: 12px;
        width: 155px;
        > img {
          width: 155px;
          height: 155px;
          margin-bottom: 20px;
        }
        .honor-name {
          font-weight: bold;
          font-size: 17px;
          color: #eeeeee;
          text-align: center;
        }
        .honor-time {
          font-size: 10px;
          color: #a0a0a0;
          margin-top: 10px;
          text-align: center;
        }
        &:last-child {
          margin: 0;
        }
      }
    }
  }
  .back_7 {
    height: 100%;
    .member-con {
      padding-top: 26px;
      display: flex;
      .team-member-item {
        width: 175px;
        height: 242px;
        border-radius: 10px;
        overflow: hidden;
        margin-right: 12px;
        .member-bg {
          height: 50px;
          background-size: 100% 100%;
          background-repeat: no-repeat;
          position: relative;
          .member-avatar {
            position: absolute;
            top: 100%;
            left: 10px;
            transform: translateY(-50%);
            width: 33px;
            height: 33px;
            border-radius: 50%;
          }
        }
        .member-info {
          padding: 27px 10px 10px;
          background: #222222;
          height: calc(100% - 50px);
          .member-detail {
            margin-bottom: 5px;
            .member-name {
              font-family: OPPOSans, OPPOSans;
              font-weight: bold;
              font-size: 15px;
              color: #ffffff;
              line-height: 18px;
              margin-right: 3px;
            }
            .member-job {
              font-family: OPPOSans, OPPOSans;
              font-weight: 500;
              font-size: 8px;
              color: #797979;
              line-height: 12px;
            }
          }
          .member-exp {
            font-family: OPPOSans, OPPOSans;
            font-weight: 400;
            font-size: 10px;
            color: #bababa;
            line-height: 13px;
            margin-bottom: 13px;
          }
          .member-project {
            font-family: OPPOSans, OPPOSans;
            font-weight: 400;
            font-size: 12px;
            color: #ffffff;
          }
        }
        &:last-child {
          margin: 0;
        }
      }
    }
  }
  .back_8 {
    height: 100%;
    .parter-con {
      column-count: 2; /* 固定2列，可根据需求改为3、4等 */
      column-gap: 12px; /* 列之间的间距 */
      height: calc(100% - 77px);
      .partnar-item {
        padding: 13px;
        background: #1e1e1e;
        border-radius: 10px;
        margin-bottom: 11px;
        break-inside: avoid; /* 防止元素被列分割 */
        .partnar-img {
          height: 27px;
          margin-bottom: 13px;
        }
        .partner-name {
          font-family: OPPOSans, OPPOSans;
          font-weight: bold;
          font-size: 13px;
          color: #eeeeee;
          line-height: 20px;
          margin-bottom: 3px;
        }
        .partner-time {
          font-family: OPPOSans, OPPOSans;
          font-weight: 400;
          font-size: 10px;
          color: #a0a0a0;
          margin-bottom: 13px;
        }
        .partner-info {
          font-family: OPPOSans, OPPOSans;
          font-weight: 400;
          font-size: 12px;
          color: #ffffff;
        }
      }
    }
  }
  .back_9 {
    height: 100%;
    position: relative;
    overflow: hidden;
    .contact-bg1 {
      position: absolute;
      right: 0;
      top: 30px;
      width: 191px;
    }
    .contact-con {
      display: flex;
      margin-top: 51px;
      background: #232120;
      border-radius: 10px;
      padding: 17px 17px 0;
      position: relative;
      .left {
        width: 155px;
        margin-right: 50px;
      }
      .mid {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        width: 233px;
        margin-right: 50px;
      }
      .right {
        flex: 1;
        min-width: 0;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        .wxqrcode {
          width: 100px;
          height: 100px;
          border-radius: 4px;
        }
      }
    }
    .contact-item {
      margin-bottom: 17px;
      .item-label {
        font-weight: bold;
        font-size: 13px;
        color: #ffffff;
        line-height: 20px;
        margin-bottom: 7px;
      }
      .item-value {
        font-size: 13px;
        color: #ffffff;
      }
    }
  }
  .back_10 {
    height: 100%;
    position: relative;
    overflow: hidden;
    .contact-bg1 {
      position: absolute;
      right: 0;
      top: 30px;
      width: 191px;
    }
    .contact-con {
      display: flex;
      margin-top: 51px;
      background: #232120;
      border-radius: 10px;
      padding: 17px 17px 0;
      position: relative;
      .left {
        width: 155px;
        margin-right: 50px;
        &:last-child {
          margin-right: 0;
        }
      }
    }
    .contact-item {
      margin-bottom: 17px;
      .item-label {
        font-weight: bold;
        font-size: 13px;
        color: #ffffff;
        line-height: 20px;
        margin-bottom: 7px;
      }
      .item-value {
        font-size: 13px;
        color: #ffffff;
      }
    }
  }
}
</style>
